import { useEffect, useState } from "react"

import { 
  CustomModal, 
  Divider, 
  StaffAutoComplete 
} from "@components"

import {
  Button, 
  Checkbox,
  ModalContent, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
} from "@heroui/react";

import PropTypes from 'prop-types';

const DuplicateModal = ({ 
  client, 
  group, 
  handleClose, 
  handleSave, 
  isSaving, 
  lessons, 
  selectedLessons, 
  show 
}) => {
  const [currentTeacher, setCurrentTeacher] = useState(null)
  const [selectedLessonIds, setSelectedLessonIds] = useState([])

  const closeModal = () => {
    handleClose()
  }

  useEffect(() => {
    setSelectedLessonIds(selectedLessons.map(lesson => lesson.id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lessons])

  const handleToggleLesson = (lessonId, isSelected) => {
    isSelected ? setSelectedLessonIds([...selectedLessonIds, lessonId]) : setSelectedLessonIds(selectedLessonIds.filter(id => id !== lessonId))
  }

  const isDisabled = selectedLessonIds.length === 0 || !currentTeacher

  return (
    <CustomModal
      isOpen={show}
      size="xl"
      handleClose={() => closeModal()}
      scrollBehavior="outside"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader>Duplicate Lessons</ModalHeader>
          
            <ModalBody>
              <div>
                <h1 className="text-lg font-semibold">Duplicate lessons from: { group.title }</h1>
                <p className="text-content2-foreground">Select the lessons you wish to copy to a new/existing group. Please note bookings will not be copied.</p>
                <Divider className="my-3" />

                <div>
                  <h2 className="mb-1 text-content2-foreground">Select the lesson to copy</h2>

                  <div className="flex flex-col">
                    {lessons.map(lesson => (
                      <Checkbox key={lesson.id} isSelected={selectedLessonIds.includes(lesson.id)} onValueChange={(isSelected) => handleToggleLesson(lesson.id, isSelected)}>
                        {lesson.name}
                      </Checkbox>
                    ))}
                  </div>

                  <Divider className="my-3" />
                </div>

                <div>
                  <h2 className="mb-1 text-content2-foreground">Select the teacher to duplicate to</h2>
                  <StaffAutoComplete clientId={client.id} onChange={(teacher) => setCurrentTeacher(teacher)} value={currentTeacher} />
                </div>
              </div>
            </ModalBody>

            <ModalFooter>
              <div className="flex justify-between w-full">
                <Button onPress={() => handleClose()} tabIndex={-1}>Cancel</Button>
                <Button color="secondary" onClick={() => handleSave(group, selectedLessonIds, currentTeacher.user_id)} tabIndex={-1} isDisabled={isDisabled} isLoading={isSaving}>Duplicate</Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </CustomModal>
  )
}

DuplicateModal.propTypes = {
  client: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  lessons: PropTypes.array.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  selectedLessons: PropTypes.array.isRequired,
  show: PropTypes.bool,
}

export default DuplicateModal